import { combineReducers } from 'redux';

import passwordChangeReducer from './ChangePassword/reducer';
import loginReducer from './Login/reducer';
import passwordResetReducer from './passwordReset/reducer';
import passwordValidateReducer from './PasswordResetValidate/reducer';
import resendVerificationEmailReducer from './ResendEmail/reducer';
import userDetailsReducer from './User/reducer';

const authReducer = combineReducers({
  loginReducer,
  passwordResetReducer,
  passwordValidateReducer,
  resendVerificationEmailReducer,
  userDetailsReducer,
  passwordChangeReducer,
});

export default authReducer;
